import { jsx as a, jsxs as d } from "react/jsx-runtime";
import * as o from "@radix-ui/react-dialog";
import h from "clsx";
import { Xmark as D, ArrowLeft as x } from "iconoir-react";
import * as n from "react";
import { cn as l } from "../../utils.js";
const E = o.Root, G = o.Trigger, f = "px-2 py-1.5", b = ({ ...e }) => /* @__PURE__ */ a(o.Portal, { ...e }), v = ({
  asChild: e = !0,
  ...t
}) => /* @__PURE__ */ a(o.Close, { asChild: e, ...t });
v.displayName = o.Close.displayName;
const u = n.forwardRef(({ className: e, ...t }, s) => (n.useEffect(() => {
  const i = document.body;
  return i.style.overflow = "hidden", () => {
    i.style.overflow = "";
  };
}, []), /* @__PURE__ */ a(
  "div",
  {
    ref: s,
    className: h(
      "fixed inset-0 z-dialog bg-black/40 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
)));
u.displayName = o.Overlay.displayName;
const H = n.forwardRef(
  ({
    className: e,
    overlayClassName: t,
    children: s,
    closeWhenInteractOutside: i = !1,
    fullScreen: r = !1,
    ...c
  }, g) => {
    const p = n.useRef(""), y = (m) => {
      if (typeof window > "u") return 0;
      const w = Math.max(0, Math.min(100, m));
      p.current = `${w * window.innerHeight * 0.01}px`;
    }, N = typeof window > "u" ? !1 : window.innerWidth <= 600;
    return y(r ? 100 : N ? 98 : 90), /* @__PURE__ */ d(b, { children: [
      /* @__PURE__ */ a(u, { className: t }),
      /* @__PURE__ */ a(
        o.Content,
        {
          ref: g,
          className: l(
            "fixed left-[50%] top-[50%] z-dialog !flex w-full translate-x-[-50%] translate-y-[-50%] !flex-col rounded-lg bg-white shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] md:w-full",
            { "max-w-[min(95%,36rem)]": !r },
            e
          ),
          onInteractOutside: i ? void 0 : (m) => {
            m.preventDefault();
          },
          style: { maxHeight: p.current },
          ...c,
          children: s
        }
      )
    ] });
  }
);
H.displayName = o.Content.displayName;
const C = ({
  className: e,
  hideClose: t = !1,
  ...s
}) => /* @__PURE__ */ d(
  "header",
  {
    className: l(f, e, {
      "border-b border-onSurface-200": !0,
      "flex items-center justify-between": !t
    }),
    ...s,
    children: [
      s.children,
      !t && /* @__PURE__ */ d(o.Close, { className: "rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none", children: [
        /* @__PURE__ */ a(D, { className: "size-3" }),
        /* @__PURE__ */ a("span", { className: "sr-only", children: "Close" })
      ] })
    ]
  }
);
C.displayName = "DialogHeader";
const M = ({
  className: e,
  ...t
}) => /* @__PURE__ */ a(
  "div",
  {
    className: l(
      "flex justify-end space-x-1 border-t border-onSurface-200",
      f,
      e
    ),
    ...t
  }
);
M.displayName = "DialogFooter";
const R = n.forwardRef(({ className: e, children: t, asChild: s = !0, onBack: i, ...r }, c) => /* @__PURE__ */ a(
  o.Title,
  {
    ref: c,
    asChild: s,
    className: l("text-title3", e),
    ...r,
    children: /* @__PURE__ */ d("div", { className: "flex items-center", children: [
      i && /* @__PURE__ */ a("button", { onClick: i, className: "me-1.25", children: /* @__PURE__ */ a(x, { width: 24, height: 24 }) }),
      /* @__PURE__ */ a("div", { children: t })
    ] })
  }
));
R.displayName = o.Title.displayName;
const T = n.forwardRef(({ className: e, asChild: t = !0, ...s }, i) => /* @__PURE__ */ a(
  o.Description,
  {
    ref: i,
    className: l(e),
    asChild: t,
    ...s
  }
));
T.displayName = o.Description.displayName;
const I = n.forwardRef(({ className: e, ...t }, s) => /* @__PURE__ */ a(
  "main",
  {
    ref: s,
    className: l("overflow-auto", f, e),
    ...t
  }
));
I.displayName = o.Content.displayName;
export {
  E as Dialog,
  I as DialogBody,
  v as DialogClose,
  H as DialogContent,
  T as DialogDescription,
  M as DialogFooter,
  C as DialogHeader,
  R as DialogTitle,
  G as DialogTrigger
};
